import {
  createFeatureSelector,
  createSelector,
  MemoizedSelector,
} from '@ngrx/store';
import { AnalysisResults } from '@sleipai/sleip-models';
import {
  adapter,
  analysisFeatureKey,
  State,
} from '../reducers/analysis.reducer';
import * as fromRouterSelector from '../../router-store/router.selectors';

export const selectAnalysisState =
  createFeatureSelector<State>(analysisFeatureKey);

export const isLoading = (state: State): boolean => state.loading;
export const isLoaded = (state: State): boolean => state.loaded;
export const activeStride = (state: State): number | null => state.activeStride;
export const analysisSharing = (state: State): boolean => state.analysisSharing;
export const analysisSharedSuccessLink = (state: State): string | null =>
  state.analysisSharedSuccessLink;
export const analysisPDFGeneratedLink = (state: State): string | null =>
  state.analysisPDFGeneratedLink;
export const analysisShareError = (state: State): string | null =>
  state.analysisShareError;

export const selectIsLoading: MemoizedSelector<object, boolean> =
  createSelector(selectAnalysisState, isLoading);
export const selectIsLoaded: MemoizedSelector<object, boolean> = createSelector(
  selectAnalysisState,
  isLoaded
);

export const selectActiveStride = createSelector(
  selectAnalysisState,
  activeStride
);

export const selectIsAnalysisSharing: MemoizedSelector<object, boolean> =
  createSelector(selectAnalysisState, analysisSharing);

export const selectIsAnalysisharedSuccessLink: MemoizedSelector<
  object,
  string | null
> = createSelector(selectAnalysisState, analysisSharedSuccessLink);

export const selectIsAnalysisPDFGeneratedLink: MemoizedSelector<
  object,
  string | null
> = createSelector(selectAnalysisState, analysisPDFGeneratedLink);

export const selectAnalysisShareError: MemoizedSelector<
  object,
  string | null
> = createSelector(selectAnalysisState, analysisShareError);

export const selectAllAnalysis: (state: object) => Partial<AnalysisResults>[] =
  adapter.getSelectors(selectAnalysisState).selectAll;

export const selectSingleAnalysis = (id: string) =>
  createSelector(
    selectAllAnalysis,
    (analysisResults: Partial<AnalysisResults>[]) => {
      if (analysisResults) {
        return analysisResults?.find((a) => a.id === id);
      } else {
        return null;
      }
    }
  );

export const selectMultipleAnalysisResults = (ids: string[]) =>
  createSelector(
    selectAllAnalysis,
    (analysisResults: Partial<AnalysisResults>[]) => {
      if (analysisResults) {
        const filteredAnalysisResults = analysisResults.filter(({ id }) => {
          return ids.indexOf(id ?? '') != -1;
        });
        return filteredAnalysisResults;
      } else {
        return null;
      }
    }
  );

export const getCurrentAnalysisEntity = (passedRecordingId?: string) =>
  createSelector(
    selectAllAnalysis,
    fromRouterSelector.selectRouteNestedParam('recordingId'),
    (
      analysisResults: Partial<AnalysisResults>[],
      urlParamRecordingId: string
    ) => {
      const recordingId = passedRecordingId ?? urlParamRecordingId;
      if (recordingId) {
        return analysisResults.find((a) => a.id === recordingId) ?? null;
      } else {
        return null;
      }
    }
  );
